import API from '../utils/request'

export function getProjects (data) {
  return API.get('/management/template/getProjects', data)
}
export function updateWhetherOrNotProject (data) {
  return API.get('/management/template/updateWhetherOrNotProject', data)
}
export function getAllTargetLocationMappingDto (data) {
  return API.get('/management/location/getAllTargetLocationMappingDto', data)
}
export function updateWhetherOrNotTargetLocationMapping (data) {
  console.log('data', data)
  return API.get('/management/location/updateWhetherOrNotTargetLocationMapping', data)
}
